import _ from 'lodash'

import { SET_SEARCH_RESULTS } from '../actions/setSearchResults'

const initialState = {}

export default function sorting(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_RESULTS:
      return action.payload
    default:
      return state
  }
}

export const getSearchResult = (state, tourId) => ({
  ..._.get(state, `searchResultsData.tourIds[${tourId}]`),
  ..._.pick(_.get(state, 'searchResultsData'), ['queryID', 'userToken'])
})

export const getSearchResults = state => _.map(_.get(state, 'searchResultsData.tourIds'), item => _.get(item, 'tourID'))
